import { render, staticRenderFns } from "./DestinationSearch.vue?vue&type=template&id=622cab12&scoped=true"
import script from "./DestinationSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationSearch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DestinationSearch.vue?vue&type=style&index=0&id=622cab12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622cab12",
  null
  
)

export default component.exports